module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-custom"
  }, [_c('md-input-container', [_c('label', [_vm._v("Название")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.title,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('title', arguments[0])
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "authors"
  }, [_vm._l((_vm.value.authors), function(author) {
    return _c('div', {
      staticClass: "author-item"
    }, [_c('md-input-container', [_c('label', [_vm._v("Фамилия")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": author.lastName,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setAuthorValue(author, 'lastName', arguments[0])
        }
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "first-name"
    }, [_c('label', [_vm._v("Имя (первая буква)")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": author.firstNameInitial,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setAuthorValue(author, 'firstNameInitial', arguments[0])
        }
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "extra-name"
    }, [_c('label', [_vm._v("Отчество (первая буква)")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": author.extraNameInitial,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setAuthorValue(author, 'extraNameInitial', arguments[0])
        }
      }
    })], 1), _vm._v(" "), _c('md-button', {
      on: {
        "click": function($event) {
          _vm.removeAuthor(author)
        }
      }
    }, [_c('md-icon', [_vm._v("close")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Удалить автора")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "authors-actions"
  }, [_c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addAuthor
    }
  }, [_vm._v("Добавить автора")])], 1)], 2), _vm._v(" "), (_vm.value.type === 'article') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Год")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.year,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('year', arguments[0])
      }
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Выпуск")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.issue,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('issue', arguments[0])
      }
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Страницы")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.pages,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('pages', arguments[0])
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.value.type === 'resource') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Адрес страницы")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "value": _vm.value.url,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('url', arguments[0])
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Наименование источника")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "value": _vm.value.source,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('source', arguments[0])
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.value.type === 'resource') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Режим доступа")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "value": _vm.value.accessMode,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('accessMode', arguments[0])
      }
    }
  }, [_c('md-option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Свободный")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "authorize"
    }
  }, [_vm._v("Требуется авторизация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.value.type === 'resource') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Дата обращеня")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "date",
      "value": _vm.value.accessDate,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('accessDate', arguments[0])
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd10856"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceDialogCustom.vue
// module id = 998
// module chunks = 1